import { CartItem } from '../../cart/storage/cart.types'
import { ProductDetailsApiResponse } from '../../products/storage'
import { fetchProductDetail } from '../../products/utils/fetchProductDetail'
import { Quote } from '../storage/types'

export const getProductsForQuote = async (
  quote: Quote,
  accountNumber: string,
): Promise<CartItem[]> => {
  try {
    const promises: Promise<ProductDetailsApiResponse>[] = []
    quote?.products.forEach((product) => {
      promises.push(fetchProductDetail(product.productId.toString(), accountNumber))
    })

    const cartItems: CartItem[] = []
    const results = await Promise.all(promises)
    results.forEach((result) => {
      const quoteProduct = quote.products.find(
        (product) => product.productId === result.masterProductId,
      )
      if (quoteProduct) {
        cartItems.push({ ...result, ...quoteProduct })
      }
    })

    return cartItems
  } catch (error) {
    return quote.products
  }
}
